<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Vehicle Deliveries",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Vehicle Deliveries",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Vehicle Deliveries",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "delivery_vehicle",
          sortable: true,
          label: "VEHICLE",
        },
        {
          key: "description",
          sortable: true,
          label: "DESCRIPTION",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE/TIME",
        },
        {
          key: "user.name",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      // Value from user input for adding category
      data: {
        description: "",
        vehicle: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        filterdata: {}
      },
      // edit category
      editdata: {
        description: "",
        vehicle: "",
        id: "",
        date: "",
        filterdata: {}
      },
      // make inputs required
      dateError: "",
      vehicleError: "",
      // delete category
      deletedata: {
        vehicle: "",
        date: "",
        id: "",
        filterdata: {}
      },
      filterdata: {
        vehicles: "",
        fromdate: moment(new Date()).format("YYYY-MM-DD"),
        todate: moment(new Date()).format("YYYY-MM-DD"),
        branch_id: 0
      }
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("vehicles", ["VehicleDeliveries", "SaveStatus", "Vehicles", "FilterStatus"]),
    ...mapGetters("auth", ["MyUserPerm", "branchid", "Branches"]),
    VehiclesFormatted() {
      if (!this.Vehicles) return [];

      return this.Vehicles.map(v => ({
        ...v,
        label: `${v.plate_number} - ${v.make} ${v.model}`
      }));
    },
    /**
     * Total no. of records
     */

    rows() {
      return this.VehicleDeliveries ? this.VehicleDeliveries.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.VehicleDeliveries ? this.VehicleDeliveries.length : 1;
  },
  updated() { },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchVehicleDeliveries: "vehicles/fetchDeliveries",
      AddDelivery: "vehicles/recordDelivery",
      EditDelivery: "vehicles/editDelivery",
      DeleteDelivery: "vehicles/deleteDelivery",
      FetchVehicles: "vehicles/fetchVehicles",
    }),
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addDelivery(modalId) {
      this.modal_id = modalId;
      if (this.data.vehicle === "") {
        this.vehicleError = "Vehicle is required";
        return;
      } else {
        this.vehicleError = "";
      }
      if (this.data.date === "") {
        this.dateError = "Date field is required";
        return;
      } else {
        this.dateError = "";
      }
      this.data.filterdata = this.filterdata;
      this.AddDelivery(this.data);
    },

    resetAddDelivery() {
      this.data.date = "";
      this.data.description = "";
      this.data.vehicle = "";
      this.dateError = "";
      this.vehicleError = "";
      this.modal_id = "";
    },
    resetEditDelivery() {
      this.editdata.date = "";
      this.editdata.description = "";
      this.editdata.vehicle = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDeleteDelivery() {
      this.deletedata.vehicle = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.dateError = "";
      this.vehicleError = "";
    },
    showEditModal(data) {
      this.editdata.date = data.item.date;
      this.editdata.id = data.item.id;
      this.editdata.vehicle = data.item.vehicle.name;
      this.editdata.description = data.item.description;
    },
    editDelivery(modalId) {
      this.modal_id = modalId;
      this.editdata.filterdata = this.filterdata;
      this.EditDelivery(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.vehicle = data.item.vehicle.name;
      this.deletedata.date = data.item.date;
      this.deletedata.id = data.item.id;
    },
    deleteVehicleDelivery(modalId) {
      this.modal_id = modalId;
      this.deletedata.filterdata = this.filterdata;
      this.DeleteDelivery(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    filterDeliveries(){
      this.FetchVehicleDeliveries(this.filterdata);
    }
  },
  created() {
    this.FetchVehicleDeliveries(this.filterdata);
    this.FetchVehicles();
  },
};
</script>

<template>
  <Layout>
    <Toasts :show-progress="true" :rtl="true" :max-messages="20" :time-out="3000" :closeable="false" :solid="true">
    </Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <b-button class="float-end" variant="primary" v-b-modal.add-delivery-modal><i class="fa fa-plus"></i>
                  Record Delivery</b-button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label>From</label>
                  <input type="date" v-model="filterdata.fromdate" class="form-control" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>To</label>
                  <input type="date" v-model="filterdata.todate" class="form-control" />
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label>VEHICLES</label>
                <model-list-select :list="Vehicles ? Vehicles : []" v-model="filterdata.vehicle" option-value="id"
                  option-text="plate_number" placeholder="Select Vehicle" @input="filterDeliveries()">
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterDeliveries()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="FilterStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" :items="VehicleDeliveries ? VehicleDeliveries : []" :fields="fields"
                responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc"
                :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(delivery_vehicle)="data">
                  {{ data.item.vehicle.plate_number }}-{{ data.item.vehicle.make }} {{ data.item.vehicle.model }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button size="sm" variant="primary" v-b-modal.edit-deliveries-modal
                      @click="showEditModal(data)"><i class="fa fa-edit"></i> Edit</b-button>
                    <b-button size="sm" variant="danger" v-b-modal.delete-delivery-modal
                      @click="showDeleteModal(data)"><i class="fa fa-trash"></i> Delete</b-button>
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <Loader v-if="!VehicleDeliveries" />
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- add delivery modal starts -->
            <b-modal id="add-delivery-modal" hide-footer @hidden="resetAddDelivery">
              <template #modal-title> Record New Delivery</template>
              <div class="form-group mb-3">
                <label>Vehicle</label>
                <model-list-select :list="VehiclesFormatted ? VehiclesFormatted : []" v-model="data.vehicle"
                  option-value="id" option-text="label" class="mb-3" placeholder="Select Vehicle"
                  @input="resetErrors()">
                </model-list-select>
                <div class="text-danger" v-if="vehicleError">
                  <em>{{ vehicleError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Date</label>
                <div class="input-group">
                  <input type="date" class="form-control" v-model="data.date" @input="resetErrors()"
                    v-limit-future-date />
                </div>
                <div class="text-danger" v-if="dateError">
                  <em>{{ dateError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Description</label>
                <div class="input-group">
                  <textarea rows="5" class="form-control" v-model="data.description" placeholder="Description"></textarea>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal"
                  @click="closeModal('add-delivery-modal')">
                  <i class="fa fa-times"></i> Close
                </button>
                <button v-if="SaveStatus" type="button" class="btn btn-primary" disabled>
                  <i class="fa fa-check"></i> Save Delivery
                  <b-spinner variant="light" small label="Saving"></b-spinner>
                </button>
                <button v-else type="button" class="btn btn-primary" @click="addDelivery('add-delivery-modal')">
                  <i class="fa fa-check"></i> Save Delivery
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
            <!-- edit modal starts -->
            <b-modal id="edit-deliveries-modal" hide-footer @hidden="resetEditDelivery">
              <template #modal-title>
                Edit Delivery by {{ editdata.vehicle }} on {{ editdata.date }}</template>
              <div class="form-group mb-3">
                <label>Description</label>
                <div class="input-group">
                  <textarea rows="5" class="form-control" v-model="editdata.description" placeholder="Description"></textarea>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Date</label>
                <div class="input-group">
                  <input type="date" class="form-control" v-model="editdata.date" @input="resetErrors()"
                    v-limit-future-date />
                </div>
                <div class="text-danger" v-if="dateError">
                  <em>{{ dateError }}</em>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal"
                  @click="closeModal('edit-deliveries-modal')">
                  <i class="fa fa-times"></i> Close
                </button>
                <button v-if="SaveStatus" type="button" class="btn btn-primary" disabled>
                  <i class="fa fa-check"></i> Save Changes
                  <b-spinner variant="light" small label="Saving"></b-spinner>
                </button>
                <button v-else type="button" class="btn btn-primary" @click="editDelivery('edit-deliveries-modal')">
                  <i class="fa fa-check"></i> Save Changes
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete delivery starts -->
            <b-modal header-bg-variant="danger" header-text-variant="light" body-text-variant="danger"
              footer-bg-variant="danger" footer-text-variant="danger" id="delete-delivery-modal" hide-footer
              @hidden="resetDeleteDelivery">
              <template #modal-title>
                Delete Delivery by {{ deletedata.vehicle }} on {{ deletedata.date }}</template>
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>
                    Do you want to delete this delivery? This is a permanent
                    action.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                  @click="closeModal('delete-delivery-modal')">
                  <i class="fa fa-times"></i> Close
                </button>
                <button v-if="SaveStatus" type="button" class="btn btn-danger" disabled>
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner variant="light" small label="Deleting"></b-spinner>
                </button>
                <button v-else type="button" class="btn btn-danger"
                  @click="deleteVehicleDelivery('delete-delivery-modal')">
                  <i class="fa fa-trash"></i> Proceed
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
